const state = {
  clickedButton: "СРОКИ",
  clickedChartButton: 0,
  selectedItem: null,
};

const getters = {
  getClickedButton: (state) => state.clickedButton,
  getClickedChartButton: (state) => state.clickedChartButton,
  getSelectedItem: (state) => state.selectedItem,
};

const actions = {
  updateClickedButton({ commit }, value) {
    commit("setClickedButton", value);
  },
  updateClickedChartButton({ commit }, value) {
    commit("setClickedChartButton", value);
  },
  updateSelectedItem({ commit }, value) {
    commit("setSelectedItem", value);
  },
};

const mutations = {
  setClickedButton(state, value) {
    state.clickedButton = value;
  },
  setClickedChartButton(state, value) {
    state.clickedChartButton = value;
  },
  setSelectedItem(state, value) {
    state.selectedItem = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
